import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { PosthogFeatureFlag } from '@app/shared/interfaces';
import { OptimizelyService } from '@app/shared/services/optimizely/optimizely.service';
import { PosthogService } from '@app/shared/services/posthog/posthog.service';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-subnav',
  templateUrl: './direct-subnav.component.html',
  styleUrls: ['./direct-subnav.component.scss'],
})
export class DirectSubnavComponent implements OnInit {
  isPrimaryUser$ = this.permissionsService.isPrimaryUser();
  isPremium$ = this.directSubscription.isPremium$;
  isBasic$ = this.directSubscription.isBasic$;
  isOnboarded$ = this.directSubscription.isOnboarded$;
  isLite$ = this.directSubscription.isLite$;
  shouldDisplayFinancialData$ = this.permissionsService.hasAccessTo(Features.PERM_DIRECT_DISPLAY_FINANCIAL_DATA);
  shouldDisplayEarningReports$ = this.posthogService.featureEnabled$(PosthogFeatureFlag.EarningReports);
  activeNavArea = '';

  instantBookEnabled$ = this.directSubscription.instantBookEnabled$;

  constructor(
    private directSubscription: DirectSubscriptionService,
    private permissionsService: UserPermissionsService,
    private optimizelyService: OptimizelyService,
    private posthogService: PosthogService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.setActiveNavArea(this.router.url);
  }

  setActiveNavArea(url: string) {
    const mappings = {
      '/direct': 'overview',
      '/direct/overview': 'overview',
      '/direct/payout-history': 'payouts',
      '/direct/payouts': 'payouts',
      '/direct/cancellation-policies': 'bookings',
      '/direct/booking-policies': 'bookings',
      '/direct/channels': 'bookings',
      '/direct/instant-book': 'bookings',
      '/direct/promo-codes': 'bookings',
      '/direct/domains': 'domains',
      '/direct/plan': 'plan',
      '/direct/earnings-reports': 'earnings-reports',
    };

    this.activeNavArea = mappings[url] || 'Unknown';
  }
}
